import React from 'react';
import QuizScoreChart from 'components/dashboard/quiz/layout/QuizScoreChart';
// import { Link } from 'react-router-dom';

type scoreProps = {
  data: any;
};

// Add this interface near the top of the file, with other type definitions
interface ScoreComponent {
  category: 'COMMUNICATION' | 'COLLABORATION' | 'MINDSET' | 'MANAGEMENT';
  percentage: number;
}

const NewShowFinalScore = (props: scoreProps) => {
  const percentage = Math.ceil(props.data.percentage);

  const color = percentage > 25 ? '#9BBCEC' : '#EC9B9B';

  const newTerms = {
    COMMUNICATION: 'Interpersonal Communication',
    COLLABORATION: 'Collaborative Engagement',
    MINDSET: 'Analytical Mindset',
    MANAGEMENT: 'Self Management',
  };

  return (
    <div className='m-1 sm:m-4'>
      <div className='hidden text-gray-500 font-semibold m-2'>
        Congratualtions! You can start Applying to Opportunitues
      </div>
      <div className='bg-gray-50 p-4 mt-8'>
        <div className='sm:flex text-gray-500 font-semibold'>
          <div>
            <div className='mb-6 text-center '>Your Score Card</div>
            <div className='flex justify-center'>
              <QuizScoreChart percentage={percentage} color={color} />
            </div>
          </div>
          {props.data.testType === 'GSAP' ? (
            <div className='grid grid-cols-2 gap-2'>
              {props.data.gsapRetting.map((skill: any) => {
                // const percentage = Math.ceil((comp.obtained * 100) / comp.max);
                return (
                  <div
                    key={skill.skill}
                    className='my-2 flex items-center bg-primary-lightest col-span-2 sm:col-span-1 rounded-3xl'>
                    <div className='bg-primary text-xs rounded-full text-center flex items-center w-12 h-12 px-3 py-1 text-white'>
                      {Math.ceil(skill.percentage)}%
                    </div>
                    <div className='flex justify-between w-full '>
                      <div className='ml-3 text-sm mt-1'>{skill.skill}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className='mt-12 sm:ml-16'>
              <div className='mb-4'>
                The Assessment assesses on the 4 essential workplace readiness
                skills :{' '}
                <span className='text-primary'>
                  Interpersonal Communication, Collaborative Engagement ,
                  Analytical Mindset & Self Management
                </span>
              </div>
              <div className='grid grid-cols-2 gap-2'>
                {props.data.finalScore.map((comp: ScoreComponent) => {
                  // const percentage = Math.ceil((comp.obtained * 100) / comp.max);
                  return (
                    <div
                      key={newTerms[comp.category]}
                      className='my-2 flex items-center bg-primary-lightest col-span-2 sm:col-span-1 rounded-3xl'>
                      <div className='bg-primary text-xs rounded-full text-center flex items-center w-12 h-12 px-3 py-1 text-white'>
                        {Math.ceil(comp.percentage)}%
                      </div>
                      <div className='flex justify-between w-full '>
                        <div className='ml-3 text-sm mt-1'>
                          {newTerms[comp.category]}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewShowFinalScore;
